import React from 'react';

interface LinkOrSpanProps {
	url?: string;
	className?: string;
	normalText: React.ReactNode;
	shortText: React.ReactNode;
}

const CheckUrl = ({url, className = 'software-show__metadata-text', normalText, shortText}: LinkOrSpanProps) => {
	const content = (
		<>
			<span className={`${className}--normal`}>{normalText}</span>
			<span className={`${className}--short`}>{shortText}</span>
		</>
	);

	return url ? (
		<a className={className} href={url}>
			{content}
		</a>
	) : (
		<span className={className}>
			{content}
		</span>
	);
};

export default CheckUrl;
